if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              //console.log(response.status);
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
              });
            this.error = false;
            const quickAddModal = this.closest("#quick-buy-model");
            if (quickAddModal) {
              document
                .querySelector("#quick-buy-model .banner--success")
                .classList.remove("hidden");
              document
                .querySelector("#quick-buy-model .buy-buttons--compact")
                .classList.remove("hidden");
              document
                .querySelector("#quick-buy-model .quick-buy-variant")
                .remove();
              document.querySelector("#quick-buy-model .product-form").remove();
              document
                .querySelector("#quick-buy-model .quick-buy-close")
                .remove();
              var success = document.querySelector(
                "#quick-buy-model .quick-buy-content-head"
              ).innerHTML;
              document.querySelector(
                "#quick-buy-model .quick-buy-add_success"
              ).innerHTML = success;
              document
                .querySelector("#quick-buy-model .quick-buy-content-head")
                .remove();
              document
                .querySelector("#quick-buy-model .quick-buy-add_success")
                .classList.remove("hidden");
              var variant_title = document.createElement("p");
              variant_title.innerHTML = response.variant_title;
              document
                .querySelector(
                  "#quick-buy-model .quick-buy-add_success .quick---title"
                )
                .appendChild(variant_title);
              this.cart.renderContents(response, false);
            } else {
              this.cart.renderContents(response);
            }
            setTimeout(function () {
              var swiper = new Swiper(".cart-drawer__recommendations .swiper", {
                slidesPerView: "auto",
                spaceBetween: 8,
                navigation: {
                  nextEl: ".cart-drawer__recommendations .swiper-button-next",
                  prevEl: ".cart-drawer__recommendations .swiper-button-prev",
                },
              });
            }, 1000);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
